<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col md="4">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="filter.search"
                  placeholder="Название старого или нового тарифа"
                  dense
                />
              </v-col>
              <v-col>
                <v-btn @click="change.show = true">Смена тарифа</v-btn>
                <v-btn @click="getData"><v-icon>autorenew</v-icon> Обновить</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <Table
          :headers="headers"
          :items="tasks"
          :loading="loading"
          :items-per-page="tasksPerPage"
          :server-items-length="totalTasks"
          :page="page"
          @update:request="updateRequest"
          item-key="id"
          class="elevation-1"
          disable-sort
        >
          <template v-slot:item.created_at="{ item }">
            {{ item.created_at | dateTime }}
          </template>
          <template v-slot:item.completed_at="{ item }">
            <span v-if="item.completed_at">
              <v-icon color="green">done</v-icon> {{ item.completed_at | dateTime }}
            </span>
            <span v-else>
              <v-icon color="blue">watch_later</v-icon> В работе
            </span>
          </template>
        </Table>
      </v-card-text>
    </v-card>
    <TariffFindModal
      :show.sync="change.show"
      :excludeId="change.excludeId"
      :title="change.title"
      @founded="onFoundTariff($event)"
    />
    <ConfirmModal
      v-if="change.fromTariff && change.toTariff"
      title="Внимание"
      :dialog.sync="confirm"
      confirmBtnText="Сменить"
      contentClass="esh-theme adminModal"
      @confirm="replaceTariff"
    >
      <template #body>
        <v-col>
          Сменяемый тариф перейдет в архив.
          Вы действительно хотите сменить тариф "{{ change.fromTariff.name }}" 
          на "{{ change.toTariff.name }}"?
        </v-col>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { ConfirmModal, Table } from '@/components/common'
import TariffFindModal from '@/views/superadmin/tariffs/TariffFindModal'
import { REPLACE_TARIFF, GET_TARIFF_REPLACEMENT_TASKS } from '@/requests/superadmin'

const initChangeState = {
  show: false,
  excludeId: null,
  fromTariff: null,
  toTariff: null,
  title: '1. Поиск тарифа для смены'
}

export default {
  name: 'TariffChangeTasksSuperAdmin',
  components: {
    TariffFindModal,
    ConfirmModal,
    Table
  },
  data() {
    return {
      headers: [
        { text: 'Дата создания', value: 'created_at' },
        { text: 'Сменяемый тариф', value: 'old_tariff.name' },
        { text: 'Новый тариф', value: 'new_tariff.name' },
        { text: 'Статус', value: 'completed_at' }
      ],
      loading: false,
      tasks: [],
      totalTasks: 0,
      tasksPerPage: BASE.LIMIT,
      page: 1,
      confirm: false,
      change: {
        show: false,
        excludeId: null,
        fromTariff: null,
        toTariff: null,
        title: '1. Поиск тарифа для смены'
      },
      filter: {
        search: ''
      }
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    'change.show': function(state) {
      if (state) {
        this.change = { ...initChangeState, show: state }
      }
    },
    'filter.search': function(state, prevState) {
      if (
        state.length > prevState.length &&
        state.length >= BASE.SEARCH_MIN_LETTERS
      ) {
        this.searchTariffs()
      } else if (
        state.length < prevState.length &&
        prevState.length >= BASE.SEARCH_MIN_LETTERS
      ) {
        this.searchTariffs()
      }
    }
  },
  methods: {
    searchTariffs: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    updateRequest({ page, itemsPerPage, offset }) {
      this.tasksPerPage = itemsPerPage
      this.page = page
      this.getData({ offset })
    },
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    onFoundTariff(tariff) {
      if (this.change.fromTariff === null) {
        this.change.fromTariff = tariff
        this.change.excludeId = tariff.id
        this.change.title = '2. Поиск тарифа который будет установлен'
      } else {
        this.change.toTariff = tariff
        this.change.show = false
        this.confirm = true
      }
    },
    async replaceTariff() {
      const { fromTariff, toTariff } = this.change

      try {
        await REPLACE_TARIFF(fromTariff.id, toTariff.id)
        this.getData()
        this.$notify({
          type: 'success',
          text: `Тариф "${fromTariff.name}" будет заменен на "${toTariff.name}"`
        })
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: `Не удалось заменить тариф "${fromTariff.name}" на "${toTariff.name}"`
        })
      }
    },
    async getData(params = {}) {
      try {
        this.loading = true
        const { data: { results, count } } = await GET_TARIFF_REPLACEMENT_TASKS({
          limit: this.tasksPerPage,
          name: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : '',
          ...params
        })

        this.totalTasks = count
        this.tasks = results
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить список задач на смену тарифа'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>